module.exports = __webpack_public_path__ + "static/media/Willowbrook-Community-Association.321db560.pdf";